export default __webpack_public_path__ + "static/media/product-18 (2).c28e0782.jpg";